// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyCkxQlceM1A3CafETQFOqECXfKu9JYoah8",
    authDomain: "lmk-chat.firebaseapp.com",
    databaseURL: "https://lmk-chat.firebaseio.com",
    projectId: "lmk-chat",
    storageBucket: "lmk-chat.appspot.com",
    messagingSenderId: "1045291135072",
    appId: "1:1045291135072:web:3fca5dce0c31ff60875305",
    measurementId: "G-46Z365LZZF"
  };

// Initialize Firebase
export default firebaseConfig;


// WEBPACK FOOTER //
// src/firebaseConfig.js